import { api, type ApiError } from '../api/client.js';

export function renderLoginPage(root: HTMLElement, onSuccess: () => void): void {
  // Use `autocomplete="off"` / `new-password` to discourage browsers from
  // injecting saved credentials into this form. Combined with the explicit
  // value reset after mount, this keeps the fields empty on every visit.
  root.innerHTML = `
    <div class="login-shell">
      <sl-card class="login-card">
        <div slot="header">
          <strong>Sign in</strong>
        </div>
        <form class="field-stack" id="login-form" autocomplete="off">
          <sl-input id="email" name="email" type="email" label="Email" required autocomplete="off"></sl-input>
          <sl-input id="password" name="password" type="password" label="Password" password-toggle required autocomplete="new-password"></sl-input>
          <sl-alert id="login-error" variant="danger" closable></sl-alert>
          <sl-button type="submit" variant="primary">Sign in</sl-button>
        </form>
      </sl-card>
    </div>
  `;

  const form = root.querySelector<HTMLFormElement>('#login-form')!;
  const errorEl = root.querySelector<HTMLElement & { open: boolean }>('#login-error')!;
  const emailEl = root.querySelector<HTMLInputElement>('#email')!;
  const passwordEl = root.querySelector<HTMLInputElement>('#password')!;
  let emailTouched = false;
  let passwordTouched = false;

  emailEl.addEventListener('sl-input', () => {
    emailTouched = true;
  });
  passwordEl.addEventListener('sl-input', () => {
    passwordTouched = true;
  });

  // Some browsers (notably Chrome) ignore `autocomplete="off"` on email/
  // password fields and prefill them anyway. Wait for the autofill pass to
  // run, then clear the values explicitly.
  //
  // Guard against clobbering real user input: if the user already typed/pasted
  // before the delayed clear fires, do not overwrite their values.
  const clearAutofilledValues = () => {
    if (!emailTouched) emailEl.value = '';
    if (!passwordTouched) passwordEl.value = '';
  };
  requestAnimationFrame(clearAutofilledValues);
  setTimeout(clearAutofilledValues, 100);

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    errorEl.open = false;
    try {
      await api.login(emailEl.value.trim(), passwordEl.value);
      onSuccess();
    } catch (err) {
      const apiErr = err as ApiError;
      errorEl.textContent = apiErr?.message ?? 'Sign in failed';
      errorEl.open = true;
    }
  });
}
